/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/MorePagesTitle/theme';

export const MorePagesTitleTheme = theme;
